import React from 'react';
import { withStyles } from "@mui/styles";
import {Button} from "@mui/material";

const styles = {

  toolbarButton: {
    padding: '5.1px 10.2px',
    fontSize: '0.7225rem',
    height: '34px',
    color: 'rgba(0, 0, 0, 0.87)',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    whiteSpace: 'nowrap',
    '& span:first-child':{
      marginLeft: '-3.4px',
      marginRight: '6.8px'
    },
    '& svg':{
      width: '1em',
      height: '1em',
    }
  },
  toolbarButtonOpen: {
    padding: '5.1px 10.2px',
    color: '#267ea6',
    borderColor: '#267ea6',
    backgroundColor: '#f6f6f6',
    fontSize: '0.7225rem',
    height: '34px',
    whiteSpace: 'nowrap',
    '& span:first-child':{
      marginLeft: '-3.4px',
      marginRight: '6.8px'
    },
    '& svg':{
      width: '1em',
      height: '1em',
    }
  },
};
function ToolbarButton(props) {
  const {label, open, children, className, classes, ...btnProps} = props;
  return <Button variant="outlined"
    {...btnProps}
    className={`${open ? classes.toolbarButtonOpen : classes.toolbarButton} ${className}`}
  >
    {label||children}
  </Button>;
}

export default withStyles(styles)(ToolbarButton);
